import { Button, Link } from "@shapr3d/frontend-lib";

import { supportEmail } from "../../config";
import useNavigation from "../../hooks/navigation";
import Heading from "../Heading/Heading";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./ZendeskLogOut.module.css";

interface ZendeskLogOutProps {
  errorMessage?: string;
}

const ZendeskLogOut = (props: ZendeskLogOutProps) => {
  const navigation = useNavigation();

  const backToProfileButton = (
    <Button onClick={() => navigation.goToProfile()} className={style.button}>
      Back to my profile
    </Button>
  );

  if (props.errorMessage) {
    return (
      <div className={style.container}>
        <div className={style.content}>
          <Heading type="h1">Logged out from Support Portal</Heading>
          <div className={style.text}>
            You&apos;ve been logged out of the Shapr3D Support Portal because of an unexpected
            error:
            <br />
            {props.errorMessage}
            <br />
            <br />
            Try logging in again by clicking{" "}
            <NewZendeskTicketLink>on this link</NewZendeskTicketLink>. You can also contact the
            support team at <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>.
          </div>
          {backToProfileButton}
        </div>
      </div>
    );
  } else {
    return (
      <div className={style.container}>
        <div className={style.content}>
          <Heading type="h1">Logged out from Support</Heading>
          <div className={style.text}>
            You have been logged out from the Shapr3D Support portal.
          </div>
          {backToProfileButton}
        </div>
      </div>
    );
  }
};

export default ZendeskLogOut;
